export const normalize = (string: string) => {
  if (!string) return ''
  return string
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replaceAll('ø', 'o')
    .replaceAll('æ', 'ae')
    .replaceAll('å', 'a')
    .replaceAll('ä', 'a')
    .replaceAll('û', 'u')
}
